import axios from 'axios'
import { HttpResponseEnum } from '../../enums/httpResponse'
import { BASE_URL_APP } from '../baseUrl'

let token = document.head.querySelector('meta[name="csrf-token"]')
axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content

export const HTTP = axios.create({
    baseURL: BASE_URL_APP
})


// se esta comentando as linhas abaixo é por conta de testes localmente

// HTTP.interceptors.response.use(r => r, async (err) => {
//     if(err.response.status == HttpResponseEnum.UNKNOWN_STATUS) {
//         alert('Ops! Sua página ficou adormecida por muito tempo e será recarregada. Depois disso, fique à vontade!')
//         window.location.href = window.location.href
//     } else if(err.response.status == HttpResponseEnum.SERVER_ERROR) {
//         alert('Ops! Ocorreu uma instabilidade emser nosso serviço. Tente novamente. Se o problema persistir entre em contato conosco!')
//     }
//     return Promise.reject(err);
// })
